import { ConfirmModal } from 'components/modal/ConfirmModal';
import { Pagination } from 'components/pagination/Pagination';
import { SubTitle } from 'components/text/SubTitle';
import { Typography, closeModal, openModal } from 'enable-ui';

import { MODAL_KEY } from 'modules/auth/core/modal-key';
import { FunctionalTest } from 'modules/dashboard/core/type';
import { CustomTypography, SubTitleStyle } from 'modules/dashboard/styles/card-item';
import { Grid_6 } from 'modules/dashboard/styles/functional-test';

import { isEmpty } from 'lodash';

import { TABLE_KEY } from 'constants/table';

import { CardItem } from '../components/CardItem';
import { Header } from '../components/Header';
import { useFunctionalTestController } from '../core/controller/functional-test';
import { FunctionalTestMethod } from '../core/enum';
import { useLibrary } from '../core/hook';

const FunctionalTestsPage = () => {
  const {
    functionalTestData,
    total,
    queryState,
    searchValue,
    onChangeSearchValue,
    goToFunctionalTestDetail,
    handleDeleteFunctionalTest,
    handleDuplicateFunctionalTest,
    handleEditFunctionalTest,
    onChangeSelectedFunctionalTest,
    selectedFunctionalTest,
    setSelectedFunctionalTest,
    onDeleteFunctionalTest,
    handleDelete,
    handleAddFunctionalTestToAssessment,
    assessmentData,
    searchAssessment,
    onChangeSearchAssessment,
  } = useFunctionalTestController();

  const { onClickAddItem } = useLibrary();

  const selectedFunctionalTestTotal = Object.keys(selectedFunctionalTest).length;

  const showCheckbox = !isEmpty(Object.keys(selectedFunctionalTest));

  const methodEntryMap = {
    [FunctionalTestMethod.Kg.toLowerCase()]: 'Weight entry',
    [FunctionalTestMethod.Time.toLowerCase()]: 'Time entry',
  };

  const getMethodEntry = (method: FunctionalTestMethod) =>
    methodEntryMap[method?.toLowerCase() as keyof typeof methodEntryMap] || 'Rep count entry';

  const renderFunctionalTestTag = (el: FunctionalTest) =>
    el.isSO2AndHR ? (
      <CustomTypography>
        <Typography>SpO2 and heart rate</Typography>
      </CustomTypography>
    ) : (
      <></>
    );

  const renderSubTitle = (el: FunctionalTest) =>
    el.type ? (
      <SubTitle
        leftTitle={<SubTitleStyle>Score entry</SubTitleStyle>}
        rightTitle={<SubTitleStyle>{el.type}</SubTitleStyle>}
      />
    ) : (
      <SubTitleStyle>{getMethodEntry(el.method)}</SubTitleStyle>
    );

  return (
    <>
      <Header
        selected={selectedFunctionalTest}
        title="Add to assessment"
        placeholderSearch="Search by assessment"
        options={assessmentData}
        setSelected={setSelectedFunctionalTest}
        onDelete={() => openModal(MODAL_KEY.DELETE_FUNCTIONAL_TEST)}
        searchValueBySelected={searchAssessment.value}
        onAdd={handleAddFunctionalTestToAssessment}
        type="functional test"
        searchValue={searchValue.value}
        onChangeSearch={onChangeSearchValue}
        onChangeSearchBySelected={onChangeSearchAssessment}
        hideDeleteAction={false}
        onClickAddItem={onClickAddItem}
      />
      {functionalTestData.length > 0 ? (
        <>
          <Grid_6>
            {functionalTestData.map((el, index) => {
              const selected = Boolean(selectedFunctionalTest[el.id]);

              return (
                <CardItem
                  key={index}
                  selected={selected}
                  onChange={onChangeSelectedFunctionalTest(el.id)}
                  goToDetailPage={() => goToFunctionalTestDetail(el.id)}
                  handleEdit={() => handleEditFunctionalTest(el.id)}
                  handleDelete={() => handleDeleteFunctionalTest(el.id)}
                  handleDuplicate={() => handleDuplicateFunctionalTest(el.id)}
                  hideAction={false}
                  name={el.name}
                  id={el.id}
                  thumbnail={el.thumbnail}
                  tag={renderFunctionalTestTag(el)}
                  subTitle={renderSubTitle(el)}
                  showCheckbox={showCheckbox}
                />
              );
            })}
          </Grid_6>
          <Pagination
            total={total.value}
            queryState={queryState}
            tableKey={TABLE_KEY.FUNCTIONAL_TEST}
          />
        </>
      ) : (
        <Typography
          variant="h3"
          weight={700}
          style={{ textAlign: 'center', justifyContent: 'center', marginTop: 30 }}
        >
          No data
        </Typography>
      )}

      <ConfirmModal
        modalKey={MODAL_KEY.DELETE_FUNCTIONAL_TEST}
        content={'Deleting will also remove them from all existing functional test.'}
        header={`Delete ${selectedFunctionalTestTotal === 0 ? '' : selectedFunctionalTestTotal} functional test`}
        onCancel={() => closeModal(MODAL_KEY.DELETE_FUNCTIONAL_TEST)}
        onSubmit={() => {
          isEmpty(selectedFunctionalTest) ? onDeleteFunctionalTest() : handleDelete();
          closeModal(MODAL_KEY.DELETE_FUNCTIONAL_TEST);
        }}
      />
    </>
  );
};

export default FunctionalTestsPage;
